@if (result(); as item) {
  <soft-ktostamm-lieferant-field-ok-data-view [item]="item"></soft-ktostamm-lieferant-field-ok-data-view>
}
